<template>
  <div>
    <title>库存管理</title>
    <section class="mainPart">
      <!--S 头部tab-->
      <header class="tabHeader">
        <p>
          <a v-if="userInfoMd.isopencardstock==1" href="javascript:;" class="isActive">券卡库存</a>
          <router-link :to="{name:'单品库存'}">单品库存</router-link>
          <router-link v-if="userInfoMd.cantransferinv==1" :to="{name:'单品库存调拨记录',params:{singlecode:'0'}}">单品库存调拨记录</router-link><!--默认进来是所有的库存调拨记录-->
        </p>
      </header>
      <!--E 头部tab-->

      <!--S 检索-->      
      <!-- <el-form inline :model="formInline" class="searchForm">
        <el-form-item label="门店">
          <el-select v-model="formInline.flowcode" filterable placeholder="请选择或输入" clearable>
              <el-option
              v-for="(item,index) in shopList"
              :key="index"
              :label="item.flowname"
              :value="item.flowcode"
              :title="item.flowname">
              </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
            <el-button type="primary" @click="query">查询</el-button>
           <el-button type="primary" plain @click="storeChoseDialogVisible = true">关联门店</el-button>
        </el-form-item>
      </el-form> -->
      <!--E 检索-->   
      <ul class="storeUl flexUI"><!--ref="storeUl"-->
        <li class="allInv">
          <span class="redColor">{{nums}}</span>
          <div>
            <p class="txtLineTwo">券卡库存汇总</p>
          </div>
        </li>
        <template v-if="cardInvData.length>0">
          <li v-for="(item,index) in cardInvData" :key="index" v-if="item.self!=1">
            <span>{{item.num}}</span>
            <div>
              <p class="txtLineTwo" :title="item.flowname">{{item.flowname}}</p>
            </div>
          </li>
        </template>
        <li v-else class="noData"><span>暂无数据</span></li>
      </ul>
      <!-- <el-table :data="cardInvData" ref="singleGoodsInv"  v-loading="vloading" class="orderTable comTable" border :maxHeight="tableHeight">         
        <el-table-column type="index" label="序号" fixed></el-table-column>
        <el-table-column label="门店" prop="flowname" sortable fixed min-width="250">
          <template slot-scope="scope">
            <p class="textFl pdr70" :title="scope.row.flowname">{{scope.row.flowname}}</p>
          </template>
        </el-table-column>
        <el-table-column label="未激活券卡数" prop="num" sortable min-width="180">
          <template slot-scope="scope">
            <span>{{scope.row.num}}</span>
          </template>
        </el-table-column>
        <template slot="empty">
          <div class="noData"><span>暂无数据</span></div>
        </template>
      </el-table> -->

    </section>
    <!-- S 选择门店 -->
   <!-- <StoreChose   :chosestoreDatas='shopList' :storeChoseDialogVisible="storeChoseDialogVisible" @closeChild="getCloseStoreCldd" @chosestoreData="chosestoreData"></StoreChose>-->
    <!-- E 选择门店 -->
  </div>
</template>
<script>
import Api from '@/apis/api'
export default {
  name: 'StoreCardInventory',
  data () {
    return {
      userInfoMd:'',
      flowcodes:'',
      nums:0,
      vloading:false,
      pageTotal:0, //总数
      currentPage:1, // 页数
      pageSize:30, // 条数
      shopList: [], //单品列表
      formInline:{
        flowcode:'',//门店编号
      },//检索表单
      cardInvData:[],//单品库存数据
      storeChoseDialogVisible:false,//关联门店
    }
  },
  components: {
    Page: resolve => require(["@/components/common/Page.vue"], resolve),
    StoreChose: resolve =>require(["@/components/CardsFolder/StoreChose.vue"], resolve), //选择门店
  },
  watch: {

  },
  methods: {
    //门店数据
    chosestoreData(type){
      let parm ='';
      if(type.length>0){
        type.map((item,index)=>{
            if(index!=0){
                parm += ',';
            }
            parm += item.flowcode;
        })
      }
        this.flowcodes = parm;
        this.saveFlowRelation()
    },
    saveFlowRelation(){
      if(this.flowcodes==''){
         return
      }
      Api.SAVEFLOWRELATION({flowcodes:this.flowcodes}).then(res =>{
        if(res.data.status=="200"){
           this.getFlowRelation()
           this.formInline.flowcode=''
           this.query()
        }else{
          this.$message.error(res.data.message)
        }
      })
         
    },
    // 关闭选择门店弹窗
    getCloseStoreCldd() {
      this.storeChoseDialogVisible = false;
    },
    // //动态获取表格高度
    // getHeight() {
    //   let storeUl = this.$refs.storeUl
    //   let tbHeight = storeUl.offsetTop; //顶部检索条件占据的高度
    //   storeUl.style.height = window.innerHeight - tbHeight - 50 + 'px';
    //   console.log(storeUl,tbHeight,storeUl.style.height,'个高的')
    // },
    getFlowRelation(){
    //  Api.GET_FLOWRELATION({}).then(res=> {
    //       if(res.data.status=="200"&&res.data.data!=null){
    //          this.shopList = res.data.data;
    //       }else{
    //          this.shopList = []
    //       }
    //  })
    },
    query(){
          this.pageSize =30;
          this.currentPage =1;
          this.getRelFlowCardStatics();
           this.getRelFlowCardStaticsSummary();
        },
    // 分页
    nowPageParam(val,vals){
      this.pageSize = val;
      this.currentPage = vals;
      this.getRelFlowCardStatics();
    },
    getRelFlowCardStatics(){
      let param ={
        //  flowcode:this.formInline.flowcode,
        //  pageparam:{
        //             pagesize: this.pageSize, //每页条数
        //             currentpage: this.currentPage, //当前页数
        //         }
      }
      this.vloading = true;
      Api.GET_RELFLOWCARDSTATICS(param).then(res =>{
          if(res.data.status=="200"&&res.data.data!=null){
            this.cardInvData =res.data.data;
            this.pageTotal = res.data.pagebean.totalnum;
            this.$refs.storeUl.bodyWrapper.scrollTop = 0;
            this.vloading = false;
            // this.$nextTick(() => {
            //   this.getHeight();
            // })
          }else{
            this.vloading = false;
            this.pageTotal = 0;
            this.cardInvData =[]
          }
       }).catch((err)=>{
         this.vloading = false;
       })
    },
    getRelFlowCardStaticsSummary(){
       Api.GET_RELFLOWCARDSTSTICSSUMMARY({flowcode:this.formInline.flowcode}).then(res =>{
         if(res.data.status=="200"&&res.data.data!=null){
            this.nums = res.data.data;
         }else{
            this.nums = 0;
         }
      })
    }
  },
  created() {
    //页面浏览器视窗变化绑定resize事件
    // window.addEventListener("resize", this.getHeight);
  },
  mounted (){
    if(localStorage.getItem('userInfoMd')){
      this.userInfoMd = JSON.parse(localStorage.getItem('userInfoMd'));
    }
    this.getFlowRelation();
    this.getRelFlowCardStatics();
    this.getRelFlowCardStaticsSummary();
  },
  destroyed() {
    // window.removeEventListener("resize", this.getHeight); //销毁监听浏览器视窗变化
  }
}
</script>

<style scoped>
.mainPart {padding: 20px; height: calc(100% - 50px);}
.searchForm {padding-top:64px;}
.total {margin:20px 10px 0;position: relative;line-height: 21px;}
.total span{margin-right:10px;white-space: nowrap;}
.total > b{font-weight: bold; color: #000;align-self: flex-start;}
.total p{flex: 1;margin-left: 10px;}

/*门店块状布局 */
.storeUl {padding-top:64px;flex-wrap: wrap; overflow-y: auto;}
.storeUl li {width: calc(25% - 14px); max-width: 420px; /*height: 149px;*/ margin:0 6px 12px; position: relative; cursor: pointer; box-sizing: border-box; overflow: hidden; text-align: center; border:solid 1px var(--main-color);border-radius:20px;}
.storeUl li:not(.noData) span {display: inline-block; margin:40px auto 20px; font-size: 28px; font-weight: 600; color:var(--main-color);white-space: nowrap;}
.storeUl .noData {padding-top: 110px!important;background-size: auto 80px!important;border: 1px solid #EBEEF5;}
.storeUl li div {width: calc(100% - 20px); padding:5px 10px; height: 40px; background:#f9fafa;display: flex; justify-content: center; align-items: center; }
.storeUl li p {font-size: 14px; font-weight: 600;text-align: center; color:var(--main-color);}
.storeUl li.allInv{border:solid 1px rgb(245 98 98 / 60%);}
.storeUl li.allInv span {color:#f56262;}
.storeUl li.allInv div {background:#f56262;}
.storeUl li.allInv p {color:#fff;}
</style>



// WEBPACK FOOTER //
// src/views/InventoryMange/StoreCardInventory.vue